// extracted by mini-css-extract-plugin
export default {"modal":"DeliveryFeeModal_modal__JUGUb"};